export type NoticeKind = "progress" | "delay";

export type NoticeItem = {
  id: string;
  kind: NoticeKind;
  author: string;
  /** 한 줄로 읽는 소식. */
  title: string;
  plan: string;
  planId?: string;
  at: string;
  unread: boolean;
};

/** 팝오버를 연 뒤 목업 목록이 나오기까지의 연출. */
export const NOTICE_LOAD_MS = 1100;

function hoursBefore(now: number, hours: number): string {
  return new Date(now - hours * 60 * 60 * 1000).toISOString();
}

/**
 * 진척 변경과 계획 지연. 최근이 앞이다.
 * 플랜 이름·사람은 샘플 여섯 플랜과 같다. 워크스페이스마다 본 플랜과 곁 플랜이 있다. 초대는 넣지 않는다.
 */
export function buildNoticeMock(now = Date.now()): NoticeItem[] {
  const items: NoticeItem[] = [
    {
      id: "notice-erp-quote",
      kind: "progress",
      author: "나",
      title: "커스터마이징 견적 정리를 시작했습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 0.5),
      unread: true,
    },
    {
      id: "notice-erp-gap",
      kind: "progress",
      author: "이아키",
      title: "GAP 분석 및 커스터마이징 목록 진척을 40%로 바꿨습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 1),
      unread: true,
    },
    {
      id: "notice-erp-fw",
      kind: "delay",
      author: "강인프라",
      title: "개발 서버 방화벽 오픈이 계획보다 늦습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 2),
      unread: true,
    },
    {
      id: "notice-robot-arm",
      kind: "delay",
      author: "한로봇",
      title: "로봇 암 조달·설치가 계획보다 6일 늦습니다",
      plan: "AI 로봇 생산 공장",
      planId: "sample-robot",
      at: hoursBefore(now, 3),
      unread: true,
    },
    {
      id: "notice-quote-price",
      kind: "delay",
      author: "송DB",
      title: "작년 단가가 섞여 단가 테이블이 계획보다 늦습니다",
      plan: "견적 자동화",
      planId: "sample-erp-quote",
      at: hoursBefore(now, 4),
      unread: true,
    },
    {
      id: "notice-mkt-legal",
      kind: "delay",
      author: "권CRM",
      title: "Braze 계약 법무 회신이 계획보다 2일 늦습니다",
      plan: "고객 마케팅 시스템",
      planId: "sample-marketing",
      at: hoursBefore(now, 5),
      unread: true,
    },
    {
      id: "notice-safety-fence",
      kind: "delay",
      author: "백제어",
      title: "안전펜스 높이가 도면과 달라 대조가 늦습니다",
      plan: "안전 인증",
      planId: "sample-robot-safety",
      at: hoursBefore(now, 6),
      unread: true,
    },
    {
      id: "notice-erp-tobe",
      kind: "progress",
      author: "최기획",
      title: "TO-BE 프로세스 설계 진척을 80%로 바꿨습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 8),
      unread: true,
    },
    {
      id: "notice-content-cal",
      kind: "progress",
      author: "나",
      title: "10월 콘텐츠 캘린더 확정을 진행 중으로 바꿨습니다",
      plan: "콘텐츠 운영",
      planId: "sample-mkt-content",
      at: hoursBefore(now, 16),
      unread: true,
    },
    {
      id: "notice-robot-vision",
      kind: "progress",
      author: "나비전",
      title: "비전 검사 모델 설계 진척을 50%로 바꿨습니다",
      plan: "AI 로봇 생산 공장",
      planId: "sample-robot",
      at: hoursBefore(now, 20),
      unread: true,
    },
    {
      id: "notice-erp-slip",
      kind: "delay",
      author: "김PM",
      title: "GAP 분석이 기준선보다 4일 늦습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 26),
      unread: false,
    },
    {
      id: "notice-mkt-journey",
      kind: "progress",
      author: "임그로스",
      title: "페르소나·고객 여정 매핑 진척을 60%로 바꿨습니다",
      plan: "고객 마케팅 시스템",
      planId: "sample-marketing",
      at: hoursBefore(now, 30),
      unread: false,
    },
    {
      id: "notice-robot-seq",
      kind: "progress",
      author: "백제어",
      title: "제어 시퀀스·인터락 진척을 30%로 바꿨습니다",
      plan: "AI 로봇 생산 공장",
      planId: "sample-robot",
      at: hoursBefore(now, 40),
      unread: false,
    },
    {
      id: "notice-erp-interview",
      kind: "progress",
      author: "최기획",
      title: "현업 인터뷰 진척을 100%로 바꿨습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 50),
      unread: false,
    },
    {
      id: "notice-mkt-metric",
      kind: "delay",
      author: "윤데이터",
      title: "성공 지표·실험 가드레일이 계획보다 3일 늦습니다",
      plan: "고객 마케팅 시스템",
      planId: "sample-marketing",
      at: hoursBefore(now, 56),
      unread: false,
    },
    {
      id: "notice-robot-layout",
      kind: "progress",
      author: "한로봇",
      title: "공장 레이아웃·물동 요구분석 진척을 100%로 바꿨습니다",
      plan: "AI 로봇 생산 공장",
      planId: "sample-robot",
      at: hoursBefore(now, 70),
      unread: false,
    },
    {
      id: "notice-erp-sso",
      kind: "delay",
      author: "나",
      title: "AD 속성 지연으로 인터페이스 설계가 계획보다 늦습니다",
      plan: "제조사 ERP 구축",
      planId: "sample-erp",
      at: hoursBefore(now, 80),
      unread: false,
    },
    {
      id: "notice-mkt-roster",
      kind: "progress",
      author: "나",
      title: "킥오프 참석자 확정을 진행 중으로 바꿨습니다",
      plan: "고객 마케팅 시스템",
      planId: "sample-marketing",
      at: hoursBefore(now, 90),
      unread: false,
    },
    {
      id: "notice-robot-safety",
      kind: "delay",
      author: "나",
      title: "안전 인증 일정 조율이 계획보다 늦습니다",
      plan: "AI 로봇 생산 공장",
      planId: "sample-robot",
      at: hoursBefore(now, 100),
      unread: false,
    },
  ];
  return items.sort((a, b) => Date.parse(b.at) - Date.parse(a.at));
}
